import styled from "styled-components";

const Ul = styled.ul`
  margin: 0;
  padding: 0;
`;

export default Ul;
